module.exports = __webpack_public_path__ + "../resources/img/addr_img.4be9d9ac.png";